import packageInfo from '../../package.json';

export const appVersion = packageInfo.version;
